import type { VariantImagesDefinition } from 'types/images'

import { F01_IMAGES } from './default'
import { F01_MEMOJI_OLDER_IMAGES } from './memoji-older'
import { F01_MEMOJI_PURPLE_IMAGES } from './memoji-purple'

export const F01_MEMOJI_PURPLE_OLDER_IMAGES = {
  ...F01_MEMOJI_PURPLE_IMAGES,
  experience: {
    background: {
      ...F01_IMAGES.experience.background,
      srcSet: [
        '/images/f01/memoji-purple-older/experience.webp',
        '/images/f01/memoji-purple-older/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      ...F01_IMAGES.experiencePitch.pitch,
      srcSet: [
        '/images/f01/memoji-purple-older/experience_pitch.webp',
        '/images/f01/memoji-purple-older/experience_pitch@2x.webp',
      ],
    },
  },
  flexible: {
    background: {
      ...F01_IMAGES.flexible.background,
      srcSet: [
        '/images/f01/memoji-purple-older/flexible.webp',
        '/images/f01/memoji-purple-older/flexible@2x.webp',
      ],
    },
  },
  stairsCardio: {
    background: {
      ...F01_IMAGES.stairsCardio.background,
      srcSet: [
        '/images/f01/memoji-purple-older/stairs_cardio.webp',
        '/images/f01/memoji-purple-older/stairs_cardio@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      ...F01_IMAGES.howOftenExercise.background,
      srcSet: [
        '/images/f01/memoji-purple-older/how_often_exercise.webp',
        '/images/f01/memoji-purple-older/how_often_exercise@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      ...F01_IMAGES.howOftenWalks.background,
      srcSet: [
        '/images/f01/memoji-purple-older/how_often_walks.webp',
        '/images/f01/memoji-purple-older/how_often_walks@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    first: {
      ...F01_IMAGES.bigResultsPitch.first,
      srcSet: [
        '/images/f01/memoji-purple-older/big-results-pitch/big_results_pitch_01.webp',
        '/images/f01/memoji-purple-older/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
    },
    second: {
      ...F01_IMAGES.bigResultsPitch.second,
      srcSet: [
        '/images/f01/memoji-purple-older/big-results-pitch/big_results_pitch_02.webp',
        '/images/f01/memoji-purple-older/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
    },
    third: {
      ...F01_IMAGES.bigResultsPitch.third,
      srcSet: [
        '/images/f01/memoji-purple-older/big-results-pitch/big_results_pitch_03.webp',
        '/images/f01/memoji-purple-older/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
    },
    mockup: F01_MEMOJI_OLDER_IMAGES.bigResultsPitch.mockup,
  },
  goalPitch: {
    mockup: F01_MEMOJI_OLDER_IMAGES.goalPitch.mockup,
  },
  socialProofMillions: {
    pitch: {
      ...F01_IMAGES.socialProofMillions.pitch,
      srcSet: [
        '/images/f01/memoji-purple-older/social_proof_millions.webp',
        '/images/f01/memoji-purple-older/social_proof_millions@2x.webp',
      ],
    },
    group: {
      ...F01_IMAGES.socialProofMillions.group,
      srcSet: [
        '/images/f01/memoji-purple-older/social-proof-millions/group.webp',
        '/images/f01/memoji-purple-older/social-proof-millions/group@2x.webp',
      ],
    },
  },
  problemAreasPitch: {
    mockup: F01_MEMOJI_OLDER_IMAGES.problemAreasPitch.mockup,
  },
  waterIntake: {
    header: {
      ...F01_IMAGES.waterIntake.header,
      srcSet: [
        '/images/f01/memoji-purple-older/water_intake.webp',
        '/images/f01/memoji-purple-older/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      ...F01_IMAGES.sleepDuration.header,
      srcSet: [
        '/images/f01/memoji-purple-older/sleep_duration.webp',
        '/images/f01/memoji-purple-older/sleep_duration@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      ...F01_IMAGES.wellnessProfile.extended,
      srcSet: [
        '/images/f01/memoji-purple-older/wellness-profile/wellness_profile_extended.webp',
        '/images/f01/memoji-purple-older/wellness-profile/wellness_profile_extended@2x.webp',
      ],
    },
    fullFigured: {
      ...F01_IMAGES.wellnessProfile.fullFigured,
      srcSet: [
        '/images/f01/memoji-purple-older/wellness-profile/wellness_profile_fullfigured.webp',
        '/images/f01/memoji-purple-older/wellness-profile/wellness_profile_fullfigured@2x.webp',
      ],
    },
    midSized: {
      ...F01_IMAGES.wellnessProfile.midSized,
      srcSet: [
        '/images/f01/memoji-purple-older/wellness-profile/wellness_profile_midsized.webp',
        '/images/f01/memoji-purple-older/wellness-profile/wellness_profile_midsized@2x.webp',
      ],
    },
    slim: {
      ...F01_IMAGES.wellnessProfile.slim,
      srcSet: [
        '/images/f01/memoji-purple-older/wellness-profile/wellness_profile_slim.webp',
        '/images/f01/memoji-purple-older/wellness-profile/wellness_profile_slim@2x.webp',
      ],
    },
  },
  subscription: {
    beforeExtended: {
      ...F01_IMAGES.subscription.beforeExtended,
      srcSet: [
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_before_extended.webp',
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_before_extended@2x.webp',
      ],
    },
    beforeFullfigured: {
      ...F01_IMAGES.subscription.beforeFullfigured,
      srcSet: [
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_before_fullfigured.webp',
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_before_fullfigured@2x.webp',
      ],
    },
    beforeMidsized: {
      ...F01_IMAGES.subscription.beforeMidsized,
      srcSet: [
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_before_midsized.webp',
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_before_midsized@2x.webp',
      ],
    },
    beforeSlim: {
      ...F01_IMAGES.subscription.beforeSlim,
      srcSet: [
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_before_slim.webp',
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_before_slim@2x.webp',
      ],
    },
    afterThin: {
      ...F01_IMAGES.subscription.afterThin,
      srcSet: [
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_after_thin.webp',
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_after_thin@2x.webp',
      ],
    },
    afterToned: {
      ...F01_IMAGES.subscription.afterToned,
      srcSet: [
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_after_toned.webp',
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_after_toned@2x.webp',
      ],
    },
    afterCurvy: {
      ...F01_IMAGES.subscription.afterCurvy,
      srcSet: [
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_after_curvy.webp',
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_after_curvy@2x.webp',
      ],
    },
    afterAverage: {
      ...F01_IMAGES.subscription.afterAverage,
      srcSet: [
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_after_average.webp',
        '/images/f01/memoji-purple-older/subscription/goal-body/paywall_comparison_after_average@2x.webp',
      ],
    },
  },
} satisfies VariantImagesDefinition<typeof F01_IMAGES>
